import { FC } from 'react';
import { Typography, Stack, SxProps, Theme } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import {CustomizableDisplayTextSX, CustomizableDisplayIconSX} from '@/components/blocks/CustomizableDisplay/style';

type CustomizableDisplayProps = {
	show?: boolean;
	sxText?: SxProps<Theme>
	sxIcon?: SxProps<Theme>
}

export const CustomizableDisplay: FC<CustomizableDisplayProps> = ({show = false, sxText, sxIcon}) => {
	if (!show) return null;

	return (
		<Stack direction="row" alignItems="center">
			<AutoAwesome sx={sxIcon ?? CustomizableDisplayIconSX} />
			<Typography sx={sxText ?? CustomizableDisplayTextSX}>
				{'Personalizado'}
			</Typography>
		</Stack>
	);
};
